import { TrackRoute } from '@portals/shared-frontend/components';

import HeroPage from '@/components/HeroPage';

import DeveloperPortalGuideContent from '../../../components/Guide/DeveloperPortalGuideContent';

export default function GettingStartedApiProviders() {
  return (
    <HeroPage
      banner="common"
      noTopMargin
      subtitle="Follow these steps to publish your APIs"
      tabTitle="Getting started - Providers"
      title="Getting started for API providers"
    >
      <TrackRoute name="API Providers" path="/getting-started/api-providers" type="generic" />
      <DeveloperPortalGuideContent contentSlug="api-providers" />
    </HeroPage>
  );
}
